/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventStatus } from '../../models/event-status';
import { PaginatedResponse } from '../../models/paginated-response';

export interface EventsControllerFindAll$Params {
  page?: number;
  limit?: number;

/**
 * Search in event name (SK or EN)
 */
  search?: string;

/**
 * Filter by tag IDs
 */
  tagIds?: Array<string>;

/**
 * Filter by active status
 */
  isActive?: boolean;

/**
 * Filter by private status
 */
  private?: boolean;

/**
 * Filter events from this date
 */
  dateFrom?: string;

/**
 * Filter events until this date
 */
  dateTo?: string;

/**
 * Sort by field (date, createdAt, updatedAt, name, status, nameSk, nameEn)
 */
  sortBy?: string;

/**
 * Sort order
 */
  sortOrder?: 'ASC' | 'DESC';

/**
 * Filter by event status
 */
  status?: EventStatus;
}

export function eventsControllerFindAll(http: HttpClient, rootUrl: string, params?: EventsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, eventsControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('tagIds', params.tagIds, {});
    rb.query('isActive', params.isActive, {});
    rb.query('private', params.private, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse>;
    })
  );
}

eventsControllerFindAll.PATH = '/events';
